import { useEffect } from "react";
import { WebViewAction } from "@/components/webview/type/bridge";
import {
  callbackMap,
  WebViewBridgeResponse,
} from "@/components/webview/utils/webViewBridge";

type ActionHandler = (payload: any) => void;
const handlerMap: Partial<Record<WebViewAction, ActionHandler>> = {};

export const registerWebViewHandler = (
  action: WebViewAction,
  handler: ActionHandler,
) => {
  handlerMap[action] = handler;
};

if (
  typeof window !== "undefined" &&
  typeof window.nativeWebViewCallback !== "function"
) {
  window.nativeWebViewCallback = (
    callbackId: string,
    response: WebViewBridgeResponse,
  ) => {
    if (callbackId && callbackMap[callbackId]) {
      //
      callbackMap[callbackId](response);
      delete callbackMap[callbackId];
    } else {
      // 앱 -> 웹
      const webViewActionHandlers = handlerMap[response.action];
      if (webViewActionHandlers) {
        webViewActionHandlers(response.payload);
      } else {
        console.warn("not exist handler ", response.action);
      }
    }
  };
}

export const useWebViewBridgeWorker = () => {
  useEffect(() => {
    const listener = (e: MessageEvent<string>) => {
      try {
        if (typeof e.data !== "string") {
          console.debug("Type of e.data is not string", e.data);
          return;
        }

        const { action, payload } = JSON.parse(e.data || "{}");

        if (action in handlerMap) {
          handlerMap[action as WebViewAction]?.(payload);
        }
      } catch (err) {
        console.warn("Failed to parse webview message", err);
      }
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, []);
};
